// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thanks-zone{font-size:90px!important;letter-spacing:2px!important;color:#cacaca!important;opacity:.85;font-weight:300!important;line-height:1.5;margin-top:40%}.content-zone{font-size:20px;line-height:1.8}.content-zone,.sub-content-zone{font-family:Roboto,-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif;color:#8a8a8a;margin-bottom:10px}.sub-content-zone{font-size:18px;line-height:1.2;padding:0 10px}", ""]);
// Exports
module.exports = exports;
